/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetStocks200ResponseAllOfData } from './GetStocks200ResponseAllOfData';
import {
    GetStocks200ResponseAllOfDataFromJSON,
    GetStocks200ResponseAllOfDataFromJSONTyped,
    GetStocks200ResponseAllOfDataToJSON,
} from './GetStocks200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetStocks200Response
 */
export interface GetStocks200Response {
    /**
     * 
     * @type {GetStocks200ResponseAllOfData}
     * @memberof GetStocks200Response
     */
    data: GetStocks200ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof GetStocks200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the GetStocks200Response interface.
 */
export function instanceOfGetStocks200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function GetStocks200ResponseFromJSON(json: any): GetStocks200Response {
    return GetStocks200ResponseFromJSONTyped(json, false);
}

export function GetStocks200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStocks200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetStocks200ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function GetStocks200ResponseToJSON(value?: GetStocks200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetStocks200ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

